// hooks/useApiError.js
import { useNavigate } from "react-router-dom";

const useApiError = () => {
  const navigate = useNavigate();

  const handleApiError = (errorData) => {
    console.log(errorData);
    if (
      (errorData?.err && errorData?.err?.name === "JsonWebTokenError") ||
      errorData?.err?.message === "invalid signature" ||
      errorData?.message === "Unauthorized"
    ) {
      console.error("Invalid signature. Logging out...");
      localStorage.clear();
      sessionStorage.clear();
      navigate("/"); // Redirect to login
      return true;
    }

    console.error(`API Error: ${errorData.message || "Unknown error"}`);

    return false;
  };

  return handleApiError;
};

export default useApiError;
